import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

import SkirmishActions from '../../actions/SkirmishActions';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import SkirmishHeader from '../../components/skirmish/SkirmishHeader';
import SkirmishResults from '../../components/skirmish/SkirmishResults';
import SkirmishStandings from '../../components/skirmish/SkirmishStandings';
import SkirmishTeams from '../../components/skirmish/SkirmishTeams';
import SkirmishStore from '../../stores/SkirmishStore';

const fetchData = () => {
  SkirmishActions.getSkirmish('summer-skirmish');
};

@connectToStores
class SummerSkirmishView extends React.Component {
  static propTypes = {
    summerSkirmishStore: PropTypes.object,
  };

  static getStores() {
    return [SkirmishStore];
  }

  static getInitialActions() {
    return [fetchData];
  }

  static getPropsFromStores() {
    return {
      summerSkirmishStore: SkirmishStore.getState(),
    };
  }

  render() {
    const {summerSkirmishStore} = this.props;
    const ssData = summerSkirmishStore.skirmish || {};
    const tags = [
      {itemProp: 'name', content: ssData.metaTitle},
      {itemProp: 'description', content: ssData.metaDescription},
      {itemProp: 'image', content: ssData.metaImage},
      {name: 'description', content: ssData.metaDescription},
      {name: 'twitter:title', content: ssData.metaTitle},
      {name: 'twitter:description', content: ssData.metaDescription},
      {name: 'twitter:image', content: ssData.metaImage},
      {property: 'og:title', content: ssData.metaTitle},
      {property: 'og:image', content: ssData.metaImage},
      {property: 'og:description', content: ssData.metaDescription},
    ];
    return (
      <div className="summer-skirmish-view">
        {summerSkirmishStore.loading || !summerSkirmishStore.skirmish ? (
          <LoadScreen show={true} />
        ) : (
          <React.Fragment>
            <Helmet meta={tags} title={ssData.metaTitle} />
            <SkirmishHeader data={ssData.header} />
            <SkirmishResults data={ssData.matchResults} />
            <SkirmishStandings data={ssData.standings} />
            <SkirmishTeams data={ssData.teams} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default SummerSkirmishView;
